import React, { useEffect, useState } from "react";

// JS Files
import LinksRightSide from "./LinksRightSide";
import LinksLeftSide from "./LinksLeftSide";

// Others File

const Links = () => {
  return (
    <>
      <div className="mx-4 md:mx-16 mb-2 mt-10 md:mt-20">
        <p className="header">پیوند ها</p>
      </div>
      <div className="grid md:grid-cols-2 gap-x-1 mt-8 md:mx-4 px-4 md:px-16">
        <LinksRightSide />
        <LinksLeftSide />
      </div>
    </>
  );
};
export default Links;
